module.exports = __webpack_public_path__ + "static/media/visitormanage.a82e8197.png";